export default {
    edit: 'ફેરફાર કરો',
    delete: 'કાઢી નાખો',
    save: 'સાચવો',
    reset: 'ફરીથી સેટ કરો',
    update: 'અપડેટ કરો',
    create: 'બનાવો',
    cancel: 'રદ કરો',
    menu: 'મેનુ',
    manage_menu: 'મેનુ મેનેજ કરો',
    id: 'આઇડી',
    title: 'શીર્ષક',
    icon: 'ચિન્હ',
    remark: 'રીમાર્ક',
    url: 'યુઆરએલ',
    status: 'સ્થિતિ',
    operations: 'ઓપરેશન્સ',
    manage_roles: 'ભૂમિકાઓ મેનેજ કરો',
    date: "તારીખ",
    name: "નામ",
    permission: "પરવાનગી",
    add_role: "ભૂમિકા ઉમેરો",
    edit_role: "ભૂમિકા સંપાદિત કરો",
    check_all: "બધા તપાસો",
    confirm: "પુષ્ટિ કરો",
    first_name: "પ્રથમ નામ",
    last_name: "છેલ્લું નામ",
    email: "ઇમેઇલ",
    date_of_birth: "જન્મ તારીખ",
    edit_user: "વપરાશકર્તા સંપાદિત કરો",
    gender: "જાતિ",
    male: "પુરૂષ",
    female: "સ્ત્રી",
    email_address: "ઈ-મેઈલ સરનામું",
    manage_users: 'વપરાશકર્તાઓને મેનેજ કરો',
    Manage_permissions: "પરવાનગીઓ મેનેજ કરો",
    add_permission: "પરવાનગી ઉમેરો",
    edit_permission: "પરવાનગી સંપાદિત કરો",
    display_name: "પ્રદર્શન નામ",
    calendar: "કૅલેન્ડર",
    general_settings: "સામાન્ય સુયોજનો",
    admin_email: "એડમિન ઇમેઇલ",
    timezone: "સમય ઝોન",
    date_format: "તારીખ ફોર્મેટ",
    time_format: "સમય ફોર્મેટ",
    logo_upload: "લોગો અપલોડ કરો",
    create_menu: "મેનુ બનાવો",
    edit_menu: "સંપાદિત કરો મેનૂ",
    menu_title: "મેનુ શીર્ષક",
    menu_icon: "મેનૂ આયકન",
    select_parent: "પૂર્વજ પસંદ કરો",
    category: "શ્રેણી",
    menu_status: "મેનુ સ્થિતિ",
    display_order: "પ્રદર્શન ઓર્ડર",
    enable: "સક્ષમ કરો",
    disable: "અક્ષમ કરો",
    updated_at: "પર સંશોધિત",
    parent_name: "પૂર્વજ નામ",
    search: "શોધો",
    '24h': "૨૪ ઘડિયાળનો ઉપયોગ કરો",
    '12h': "૧૨ ઘડિયાળનો ઉપયોગ કરો",
    select_timezone: "ટાઇમઝોન પસંદ કરો",
    select_date_format: "તારીખ ફોર્મેટ પસંદ કરો",
    select_time_format: "સમય ફોર્મેટ પસંદ કરો",
    select_language: "ભાષા પસંદ કરો",
    select_currency: "ચલણ પસંદ કરો",
    admin_email_required: "કૃપા કરીને સંચાલક ઇમેઇલ સરનામું ઇનપુટ કરો",
    admin_email_invalid: "માન્ય ઇમેઇલ સરનામું ઇનપુટ કરો",
    menu_title_required: "કૃપા કરીને ઇનપુટ મેનૂ શીર્ષક",
    language: "ભાષા",
    currency: "ચલણ"
}



// WEBPACK FOOTER //
// ./src/assets/lan/gu.js